import { setupMobileNav } from "./modules/mobile-nav";
import './hgs-main-common';


/* eslint-disable no-var */
// declared via nested script page (/hospital-files/MobileMenuData.js)
declare var mobileMenuDataSource;
/* eslint-enable no-var */

jQuery(function () {
    try {
        setupMobileNav(mobileMenuDataSource);
    } catch (e) { console.dir(e); }
});